<template>
  <!-- Content Left Rail -->
  <div class="settings-center-rail">
    <!-- <call-log v-if="settingsNavSelected == 'calls'"></call-log> -->
    <sms-log v-if="settingsNavSelected == 'text-log'"></sms-log>
    <conversations
      v-if="settingsNavSelected == 'text-uniq-conv'"
    ></conversations>
  </div>
</template>

<script>
const SmsLog = () =>
  import(
    /* webpackChunkName: "components-reports-sms-SMSLog" */ `./sms/SMSLog.vue`
  );
const Conversations = () =>
  import(
    /* webpackChunkName: "components-reports-sms-Conversations" */ `./sms/Conversations.vue`
  );

export default {
  name: "TextCenterRail",
  components: {
    SmsLog,
    Conversations
  },
  props: {
    msg: String
  },
  data: function() {
    return {
      toggleFilter: 1
    };
  },
  created() {},
  watch: {},
  computed: {
    settingsNavSelected() {
      return this.$parent.$parent.$parent.settingsNavSelected;
    }
  },
  methods: {
    navigateTo(settingType) {
      settingType;
    }
  }
};
</script>

<style scoped lang="stylus">
div.settings-left-nav, div.settings-left-nav div {
  background-color: rgb(241, 241, 241);
  width: 100%;
}
.settings-left-nav div.v-list {
  padding: 0;
}
.v-list-item__title {
  padding: 1.5rem 2rem 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  text-transform: uppercase;
}
.subtitle-1 {
  font-size: 1rem;
  font-weight: 400;
}
.v-list-item {
  padding: .5rem 2rem;
}
.settings-center-rail {
  width: 100%;
  padding: 0;
}
</style>
